import { Component, ViewEncapsulation, inject, ChangeDetectionStrategy } from '@angular/core';
import { BankAccount, BankConnection } from 'taxtank-core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '@shared/component/base/base.component';

/**
 * @TODO rename
 * add bank connection/bankAccounts process for both flows: manual and basiq
 */
@Component({
  selector: 'app-bank-connections-add-dialog',
  templateUrl: './bank-connections-add-dialog.component.html',
  styleUrls: ['./bank-connections-add-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BankConnectionsAddDialogComponent extends BaseComponent {
  connection: BankConnection = inject(MAT_DIALOG_DATA);
  dialogRef = inject(MatDialogRef<BankConnectionsAddDialogComponent>);

  /**
   * New imported/created bank accounts
   */
  bankAccounts: BankAccount[];

  /**
   * reset filled data, move to the first step
   * @TODO Alex takes too long to reset (probably because of images)
   */
  restart(): void {
    this.connection = null;
    this.bankAccounts = null;
  }
}
